export interface Faq {
  question: string
  answer: string[]
}

export const faqs: Faq[] = [
  {
    question: '¿Cuánto tiempo lleva ver cambios?',
    answer: ['El Kit SOS baja el conflicto hoy; los cambios profundos, en 2 o 3 semanas.'],
  },
  {
    question: '¿Funciona si mi hijo está muy cerrado?',
    answer: ['Sí: el Tomo 2 y el Mapa de Frases están hechos para adolescentes cerrados.'],
  },
  {
    question: '¿Esto reemplaza terapia?',
    answer: ['No. Si hay señales graves, el Tomo 6 te indica cuándo derivar a un profesional.'],
  },
  {
    question: '¿Es compatible con padres separados?',
    answer: ['Totalmente, y funciona mejor si ambos lo aplican desde sus casas.'],
  },
  {
    question: '¿Qué agrega el Método 12 Semanas?',
    answer: ['Hoja de ruta semanal, 2 llamadas de estrategia y garantía en la semana 4.'],
  },
]

export interface ComparisonRow {
  situation: string
  without: string
  with: string
}

export const comparisonRows: ComparisonRow[] = [
  {
    situation: 'Por dónde empezar',
    without: 'Leés 360 págs y decidís solo',
    with: 'Diagnóstico de tu caso en semanas 1-2',
  },
  {
    situation: 'Si algo no funciona',
    without: 'Improvisás sin validación',
    with: 'Llamada de estrategia para ajustar',
  },
  {
    situation: 'Progreso',
    without: 'Lo medís a ojo',
    with: 'Tracker semanal verificable',
  },
  {
    situation: 'Sostener el cambio',
    without: 'Volvés a empezar de cero',
    with: 'Plan de blindaje semanas 7-12',
  },
]

export interface MethodPhase {
  weeks: string
  name: string
  focus: string
}

export const methodPhases: MethodPhase[] = [
  {
    weeks: 'Semanas 1-2',
    name: 'Diagnóstico',
    focus: 'Tu caso, tus patrones de conflicto y tu plan personalizado.',
  },
  {
    weeks: 'Semanas 3-5',
    name: 'Implementación 1',
    focus: 'Protocolo C.A.L.M.A. y Kit SOS en acción: primeros cambios.',
  },
  {
    weeks: 'Semanas 6-8',
    name: 'Implementación 2',
    focus: 'Comunicación más profunda y límites que se sostienen.',
  },
  {
    weeks: 'Semanas 9-10',
    name: 'Consolidación',
    focus: 'Reconexión real y validación profesional de tus avances.',
  },
  {
    weeks: 'Semanas 11-12',
    name: 'Blindaje',
    focus: 'Mantenimiento, prevención de recaídas y autonomía.',
  },
]

export const methodExtras: string[] = [
  '2 llamadas de estrategia (semanas 4 y 9)',
  'Tracker semanal personalizado',
  'Garantía acelerada: cambios en la semana 4 o 100% reembolso',
]
